import { useTranslation } from 'react-i18next';
import { href, Link, useNavigate } from 'react-router';

import { useQueryClient } from '@tanstack/react-query';

import { Button, Menu, Text, toast } from '@valwin/facto/components';
import { CircleUserIcon } from '@valwin/facto/icons';

import { sessionQueries, useProfile } from '~entities/session';
import { logout } from '~features/auth';
import { clearAllRevisions } from '~shared/api/revisionsKeys';
import { ROUTES, usePharmacyId } from '~shared/routes';

export function Profile() {
  const { t } = useTranslation();
  const pharmacyId = usePharmacyId();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const profile = useProfile(pharmacyId);

  const handleLogout = async () => {
    try {
      await logout(pharmacyId);
    } catch {
      toast.error('Erreur', {
        description: "Impossible d'effectuer la déconnexion",
      });
    }

    clearAllRevisions(pharmacyId);
    // The session must stay cached until the authenticated tree is unmounted
    await navigate(href(ROUTES.auth.login, { pharmacyId }));
    queryClient.removeQueries({ queryKey: sessionQueries.all(pharmacyId) });
  };

  return (
    <Menu loopFocus positioning={{ placement: 'bottom-end' }}>
      <Menu.Trigger asChild>
        <Button size="sm" variant="ghost" colorPalette="gray">
          <Text
            as="span"
            color="brand.solid"
            fontWeight="bold"
            letterSpacing="wider"
          >
            {profile?.shortName ?? ''}
          </Text>
          <CircleUserIcon size="md" color="brand.solid" />
        </Button>
      </Menu.Trigger>

      <Menu.Content>
        <Menu.Item key="Profil" value={t('navigation profile')}>
          <Link
            to={href(ROUTES.profile, { pharmacyId })}
            style={{
              color: 'inherit',
              outline: 'none',
              width: '100%',
              height: '100%',
              textDecoration: 'none',
            }}
          >
            {t('navigation profile')}
          </Link>
        </Menu.Item>
        <Menu.Item key="Configurer" value={t('navigation configure')}>
          <Link
            to={href(ROUTES.configure, { pharmacyId })}
            style={{
              color: 'inherit',
              outline: 'none',
              width: '100%',
              height: '100%',
              textDecoration: 'none',
            }}
          >
            {t('navigation configure')}
          </Link>
        </Menu.Item>
        <Menu.DangerItem
          key="Déconnexion"
          value={t('navigation logout')}
          onClick={handleLogout}
        >
          {t('navigation logout')}
        </Menu.DangerItem>
      </Menu.Content>
    </Menu>
  );
}
